import { calculateOptionsPrice, calculateTotalPrice, formatKoreanWon } from '../model/configuration';
import type { SelectedOptions } from '../types';

export interface PriceSummaryProps {
  selectedOptions: SelectedOptions;
}

export function PriceSummary({ selectedOptions }: PriceSummaryProps) {
  return (
    <section className="price-summary" aria-label="가격 요약">
      <header className="price-summary__header">
        <h2 className="price-summary__title">예상 견적</h2>
        <span className="price-summary__badge">옵션 반영</span>
      </header>
      <dl className="price-summary__rows">
        <div className="price-summary__row">
          <dt>기본 가격</dt>
          <dd data-testid="price-base">{formatKoreanWon(selectedOptions.model.basePrice)}</dd>
        </div>
        <div className="price-summary__row">
          <dt>선택 옵션</dt>
          <dd data-testid="price-options">{formatKoreanWon(calculateOptionsPrice(selectedOptions))}</dd>
        </div>
        <div className="price-summary__row price-summary__row--total">
          <dt>총 가격</dt>
          <dd data-testid="price-total">{formatKoreanWon(calculateTotalPrice(selectedOptions))}</dd>
        </div>
      </dl>
    </section>
  );
}
